// src/components/Logo.jsx
import React from 'react';
import logoDark from '../assets/images/pilari_dark.png';   // untuk light mode
import logoLight from '../assets/images/pilari_light.png'; // untuk dark mode

const Logo = ({ isDark = false, className = 'h-8' }) => {
  return (
    <img
      src={isDark ? logoLight : logoDark}
      alt="Pilari Logo"
      className={className}
    />
  );
};

export default Logo;
